import React__default from 'react';
import { useController, useWatch } from 'react-hook-form';
import { Switch } from '../../../atoms/Switch.js';
import { TitleGroup } from '../../TitleGroup.js';
import { ContentWithTooltip } from '../../Tooltip/ContentWithTooltip.js';
import { FormItem } from '../FormItem.js';

/**
 * Blue check icon for switch read-only mode
 */
const BlueCheckIcon = () => (React__default.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '16', height: '16', viewBox: '0 0 16 16', fill: 'none' },
    React__default.createElement("path", { d: 'M8 1.00049C11.8661 1.00057 15 4.13439 15 8.00049C14.9998 11.8664 11.866 15.0004 8 15.0005C4.13398 15.0005 1.00021 11.8665 1 8.00049C1 4.13433 4.13385 1.00049 8 1.00049ZM10.0664 5.84424C9.99581 5.85683 9.92835 5.88339 9.86816 5.92236C9.80794 5.96139 9.75618 6.01244 9.71582 6.07178L7.39258 9.32373L6.22656 8.15771C6.1245 8.06268 5.98905 8.01072 5.84961 8.01318C5.71023 8.01572 5.5771 8.07281 5.47852 8.17139C5.37996 8.27002 5.32375 8.40306 5.32129 8.54248C5.31883 8.68198 5.37071 8.81736 5.46582 8.91943L7.08105 10.5347C7.13629 10.5898 7.20309 10.6318 7.27637 10.6587C7.34972 10.6856 7.428 10.6964 7.50586 10.6899C7.58368 10.6835 7.65961 10.6601 7.72754 10.6216C7.79525 10.5831 7.85406 10.5306 7.89941 10.4673L10.5918 6.69775C10.6348 6.64037 10.6662 6.57496 10.6836 6.50537C10.701 6.43581 10.7043 6.36335 10.6934 6.29248C10.6824 6.22156 10.6568 6.1534 10.6191 6.09229C10.5815 6.03124 10.532 5.97773 10.4736 5.93604C10.4154 5.89449 10.3491 5.86488 10.2793 5.84912C10.2094 5.83338 10.137 5.83166 10.0664 5.84424Z', fill: '#0066CC' })));
/**
 * Gray X icon for switch read-only mode
 */
const GrayXIcon = () => (React__default.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '16', height: '16', viewBox: '0 0 16 16', fill: 'none' },
    React__default.createElement("path", { d: 'M8 1.00049C11.8661 1.00057 15 4.13439 15 8.00049C14.9998 11.8664 11.866 15.0004 8 15.0005C4.13398 15.0005 1.00021 11.8665 1 8.00049C1 4.13433 4.13385 1.00049 8 1.00049ZM9.61914 5.83252C9.54685 5.8338 9.47523 5.84997 9.40918 5.87939C9.34324 5.90882 9.2836 5.95156 9.23438 6.00439L8 7.23877L6.76465 6.00439C6.71536 5.95152 6.65587 5.90881 6.58984 5.87939C6.52397 5.85009 6.45294 5.83383 6.38086 5.83252C6.30856 5.83124 6.23599 5.8445 6.16895 5.87158C6.10198 5.89866 6.04131 5.93965 5.99023 5.99072C5.93923 6.04176 5.89913 6.10254 5.87207 6.16943C5.84504 6.23636 5.83179 6.30821 5.83301 6.38037C5.83428 6.4526 5.84953 6.52433 5.87891 6.59033C5.90832 6.65636 5.95103 6.71585 6.00391 6.76514L7.23926 8.00049L6.00391 9.23486C5.951 9.28416 5.90834 9.34362 5.87891 9.40967C5.84948 9.47571 5.83428 9.54734 5.83301 9.61963C5.83176 9.69186 5.84502 9.76359 5.87207 9.83057C5.89911 9.89748 5.93923 9.95822 5.99023 10.0093C6.04129 10.0603 6.10201 10.1013 6.16895 10.1284C6.23599 10.1555 6.30856 10.1688 6.38086 10.1675C6.45296 10.1662 6.52396 10.1499 6.58984 10.1206C6.65589 10.0912 6.71535 10.0485 6.76465 9.99561L8 8.76123L9.23438 9.99561C9.28359 10.0484 9.34326 10.0912 9.40918 10.1206C9.47522 10.15 9.54685 10.1662 9.61914 10.1675C9.69133 10.1688 9.76311 10.1554 9.83008 10.1284C9.89713 10.1013 9.95863 10.0604 10.0098 10.0093C10.0607 9.95822 10.1009 9.89745 10.1279 9.83057C10.155 9.76359 10.1682 9.69185 10.167 9.61963C10.1657 9.54733 10.1495 9.47572 10.1201 9.40967C10.0907 9.34376 10.0489 9.28408 9.99609 9.23486L8.76074 8.00049L9.99609 6.76514C10.0489 6.7159 10.0907 6.65626 10.1201 6.59033C10.1495 6.52428 10.1657 6.45267 10.167 6.38037C10.1682 6.30821 10.155 6.23636 10.1279 6.16943C10.1009 6.10257 10.0607 6.04176 10.0098 5.99072C9.95863 5.93959 9.89713 5.89866 9.83008 5.87158C9.76313 5.8446 9.69131 5.83125 9.61914 5.83252Z', fill: '#6B7280' })));
/**
 * SwitchFormField - A form field component for switch/toggle input.
 *
 * Supports both boolean and object values:
 * - Boolean mode (default): field value is true/false
 * - Object mode: when objectValue is provided, field value is an object when ON, undefined when OFF
 *
 * @example
 * ```tsx
 * // Boolean mode (default)
 * <Form schema={schema} onSubmit={handleSubmit}>
 *   <SwitchFormField
 *     schemaField="notifications"
 *     labelText="Enable notifications"
 *   />
 * </Form>
 *
 * // Object mode
 * <SwitchFormField
 *   schemaField="paymentConfig"
 *   labelText="Enable payment"
 *   objectValue={{ paymentTypeEnum: 'CHECKOUT_FULL_PAYMENT' }}
 * />
 * ```
 */
function SwitchFormField({ schemaField, labelText, descriptionText, isReadOnly, isDisabled, required, orientation, className, id, linkedField, togglePosition, level, showFieldToggle, objectValue, titleWeight, disabledTooltip = "You don't have permission to change this setting", ...switchProps }) {
    const { field } = useController({
        name: schemaField,
        shouldUnregister: false,
    });
    // Watch the field value to ensure component re-renders when it changes
    const fieldValue = useWatch({ name: schemaField });
    // Determine if we're in object mode
    const isObjectMode = objectValue !== undefined;
    // Convert field value to boolean for the switch
    // Use fieldValue from useWatch to ensure reactivity
    const getBooleanValue = () => {
        if (isObjectMode) {
            // In object mode: truthy object = true, undefined/null = false
            return !!(fieldValue && typeof fieldValue === 'object');
        }
        // In boolean mode: use value directly
        return fieldValue ?? false;
    };
    // Handle switch change
    const handleChange = (isSelected) => {
        if (isObjectMode) {
            // In object mode: set object when ON, undefined when OFF
            if (isSelected) {
                const objValue = typeof objectValue === 'function' ? objectValue() : objectValue;
                field.onChange(objValue);
            }
            else {
                field.onChange(undefined);
            }
        }
        else {
            // In boolean mode: set boolean directly
            field.onChange(isSelected);
        }
    };
    const booleanValue = getBooleanValue();
    if (isReadOnly) {
        const title = required ? `${labelText} (required)` : labelText;
        const iconComponent = booleanValue === true ? React__default.createElement(BlueCheckIcon, null) : React__default.createElement(GrayXIcon, null);
        return (React__default.createElement("div", { className: className },
            React__default.createElement(TitleGroup, { title: title, description: descriptionText, level: level || 'subgroup', maxWidth: 'full', leftComponent: iconComponent, titleWeight: titleWeight || 'regular' })));
    }
    // Helper function to wrap Switch with tooltip if disabled
    const wrapSwitchWithTooltip = (switchElement) => {
        if (isDisabled && disabledTooltip) {
            // Type assertion needed because ContentWithTooltip expects ReactElement<DOMAttributes<HTMLElement>, string>
            // but Switch returns a different type. This is safe because ContentWithTooltip wraps content in a div anyway.
            return (React__default.createElement(ContentWithTooltip, { content: switchElement, tooltipContent: disabledTooltip }));
        }
        return switchElement;
    };
    // Card variant: use TitleGroup with toggle on left or right
    if (togglePosition) {
        const switchComponent = wrapSwitchWithTooltip(React__default.createElement(Switch, { ...switchProps, isSelected: booleanValue, onChange: handleChange, onBlur: field.onBlur, isDisabled: isDisabled, isReadOnly: isReadOnly }));
        return (React__default.createElement("div", { className: className },
            React__default.createElement(TitleGroup, { title: labelText, description: descriptionText, level: level || 'subgroup', maxWidth: 'full', titleWeight: titleWeight || 'regular', ...(togglePosition === 'left'
                    ? { leftComponent: switchComponent }
                    : { rightComponent: switchComponent }) })));
    }
    // Default variant: use standard FormItem layout
    // Skip adapter injection for isSelected and onChange when in object mode to preserve custom handling
    const switchElement = (React__default.createElement(Switch, { ...switchProps, isSelected: booleanValue, onChange: handleChange, onBlur: field.onBlur, isDisabled: isDisabled, isReadOnly: isReadOnly }));
    return (React__default.createElement(FormItem, { schemaField: schemaField, labelText: labelText, descriptionText: descriptionText, required: required, orientation: orientation, className: className, id: id, isDisabled: isDisabled, linkedField: linkedField, showFieldToggle: showFieldToggle, skipAdapterProps: isObjectMode ? ['isSelected', 'onChange'] : undefined }, wrapSwitchWithTooltip(switchElement)));
}

export { BlueCheckIcon, GrayXIcon, SwitchFormField };
//# sourceMappingURL=SwitchFormField.js.map
